import React from 'react';
import PropTypes from 'prop-types';

import { useHideEditControls } from 'common/disabled-context/read-only';

// The inline "add an item" form under a farm list; the read-only page view drops it whole.
const AddFormContainer = ({ className, children }) =>
  useHideEditControls() ? null : <div className={className}>{children}</div>;

AddFormContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

AddFormContainer.defaultProps = {
  className: undefined,
  children: null
};

export default AddFormContainer;
